export default __webpack_public_path__ + "static/media/tiendas.8d61a24c.jpg";